import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ ...params }) => {
  return await dponetAPI.get(`/answer_option_tickets`, {
    params,
  })
}

const changeResponsibles = async ({ ...data }) => {
  return await dponetAPI.patch(`/answer_option_tickets/change_responsibles`, {
    answerOptionTickets: { ...data },
  })
}

export default {
  get,
  changeResponsibles,
}
